import{_ as r}from"./_baseToString.js";var t=r;var a=function(r){return null==r?"":t(r)};export{a as t};
